import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import styles from './styles';

interface IndicationComparisonTitleProps {
  title: string;
}

const IndicationComparisonTitle = ({
  title
}: IndicationComparisonTitleProps): React.ReactElement | null => {
  if (!title) return null;
  return (
    <Box sx={styles.titleSection}>
      <Typography id='alert-dialog-title' variant='h6'>
        {title}
      </Typography>
    </Box>
  );
};

export default IndicationComparisonTitle;
